export const getShortFeeTitle = (fee: { title?: string }) => {
  return (fee.title ?? "").split(" ").pop()
}
